import TableTemplate from "../../TableTemplate/tableTemplate";
import {
  IPermissionsTableReport,
  IPermissionsTableSearchParam,
} from "../../../Interfaces/roleAndPermissionsInterfaces";
import { getPermissionsTable } from "../../../Requests/roleAndPermissionsRequests";
import TableUI from "./TableUI";

const PermissionsTable = () => {
  return (
    <TableTemplate<IPermissionsTableSearchParam, IPermissionsTableReport>
      getDataTable={getPermissionsTable}
      TableUI={TableUI}
      pagesize={1000}
      tableWrapperClassname="!w-fit"
    />
  );
};

export default PermissionsTable;
